(() => {
  const ITEM_SELECTOR = '[data-shq-box-id]:not([data-shq-box-id=""])';

  const escapeHtml = (value) => String(value).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;'
  }[char]));

  function getRoot() {
    return window.Shopify?.routes?.root || '/';
  }

  function lockBundleItem(item) {
    item.classList.add('shq-cart-bundle-item');

    item.querySelectorAll(
      'quantity-input, .quantity, .quantity-popover-container, .cart-item__quantity-wrapper, .cart-item__quantity, [name="updates[]"]'
    ).forEach((element) => {
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
    });

    item.querySelectorAll(
      'cart-remove-button, .cart-remove-button, a[href*="/cart/change"], button[name="minus"], button[name="plus"]'
    ).forEach((element) => {
      element.hidden = true;
      element.setAttribute('aria-hidden', 'true');
    });

    if (!item.querySelector('[data-shq-fixed-quantity]')) {
      const quantityHost = item.querySelector('.cart-item__quantity')
        || item.querySelector('.cart-item__details')
        || item;
      const fixed = document.createElement('div');
      fixed.className = 'shq-cart-fixed-quantity';
      fixed.dataset.shqFixedQuantity = '';
      fixed.textContent = 'Quantity: 1 (fixed as part of this box)';
      quantityHost.appendChild(fixed);
    }
  }

  function addRemoveButton(boxId, items) {
    const first = items[0];
    if (!first || first.querySelector('[data-shq-remove-box]')) return;

    const host = first.querySelector('.cart-item__details') || first;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--secondary shq-cart-remove-box';
    button.dataset.shqRemoveBox = boxId;
    button.innerHTML = 'Remove bundle';
    button.addEventListener('click', () => removeBundle(boxId, button));
    host.appendChild(button);
  }

  async function removeBundle(boxId, button) {
    if (!boxId || button.disabled) return;
    button.disabled = true;
    button.textContent = 'Removing box…';

    try {
      const root = getRoot();
      const cartResponse = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      const cart = await cartResponse.json();
      if (!cartResponse.ok) throw new Error('Unable to read the cart.');

      const updates = {};
      cart.items.forEach((item) => {
        if (item.properties?.['_Sugar HQ Box ID'] === boxId) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        throw new Error('This box could not be found in the cart.');
      }

      const updateResponse = await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ updates })
      });

      const result = await updateResponse.json();
      if (!updateResponse.ok) {
        throw new Error(result.description || result.message || 'Unable to remove the box.');
      }

      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Remove bundle';
      window.alert(error.message || 'Something went wrong. Please try again.');
    }
  }

  function initialiseBundleCart(scope = document) {
    const groups = new Map();

    scope.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
      const boxId = item.dataset.shqBoxId;
      if (!boxId) return;
      lockBundleItem(item);
      if (!groups.has(boxId)) groups.set(boxId, []);
      groups.get(boxId).push(item);
    });

    groups.forEach((items, boxId) => addRemoveButton(boxId, items));
  }

  function init() {
    initialiseBundleCart(document);

    const observer = new MutationObserver(() => initialiseBundleCart(document));
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
